// Tool-shortcut suppression for the cue/annotation auto-focus race.
//
// When a cue or note is created, a text field auto-focuses a beat later. A keystroke
// typed in that gap lands on the document (not the field yet), so the palette's
// single-key tool shortcuts fire instead of typing. We suppress those shortcuts from
// the moment of creation until the field actually receives focus (a focusin releases
// it, after which the palette's existing input/textarea target-check protects typing).
// A safety timeout guarantees shortcuts never stay stuck if focus never lands.

let suppressed = false;
let fallbackTimer = null;

export function suppressShortcuts() {
    suppressed = true;
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(() => {
        suppressed = false;
        fallbackTimer = null;
    }, 3000);
}

export function releaseShortcuts() {
    suppressed = false;
    if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
    }
}

export function areShortcutsSuppressed() {
    return suppressed;
}


// WEBPACK FOOTER //
// ./src/lib/shortcutSuppress.js